import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { AverageageofsugarcaneEditService } from '../../service/averageageofsugarcane-edit/averageageofsugarcane-edit.service';

@Component({
	selector: 'app-averageageofsugarcane-edit',
	templateUrl: './averageageofsugarcane-edit.component.html',
	providers: [
		AverageageofsugarcaneEditService,
		HttpModule
	]
})
export class AverageageofsugarcaneEditComponent implements OnInit {

	private token;
	private sub: any;
	average: FormGroup;
	ID: string;
	Nome: string;
	Ativo: boolean;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private averageageofsugarcaneEditService: AverageageofsugarcaneEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.average = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.averageageofsugarcaneEditService.loadAverage(this.token, this.ID).subscribe(result => {
				var updateAverage = result.Result;
				this.average.setValue({
					ID: updateAverage.ID,
					Nome: updateAverage.Nome,
					Ativo: updateAverage.Ativo
				});
			})
		}, error => {
			console.log(error);
			
		});
	}

	editAverage(value: any) {
		this.averageageofsugarcaneEditService.editAverage(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Idade Média Canavial editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/idade-media-canavial');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/idade-media-canavial');
	}

}



// WEBPACK FOOTER //
// ./src/app/averageageofsugarcane/component/averageageofsugarcane-edit/averageageofsugarcane-edit.component.ts